// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__jQ6me","amount":"Amount_amount__27c_K","tip":"Amount_tip__2yoUQ","tipHeader":"Amount_tipHeader__3ATqM","tipsWrap":"Amount_tipsWrap__3wfFZ"};